import { t } from 'ttag'

const Tuition = ({ tuition }) => {
  const toCurrency = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3)
  }
  const data = () => {
    return (
      <div>
        <p className="instructions">{t`The table below contains estimates costs for full-time beginning undergraduate students.`}</p>
        <table className="tbl enrollment-table">
          <thead>
            <tr>
              <th>{t`Location`}</th>
              <th className="ay1">{tuition.firstYear}</th>
              <th className="ay2">{tuition.secondYear}</th>
              <th className="ay3">{tuition.thirdYear}</th>
              <th className="ay4">{tuition.fourthYear}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="even">
              <td>{t`In District`}</td>
              <td className="idcf1">
                {toCurrency(tuition.inDistrictTuitionAndFeesFirstYear)}
              </td>
              <td className="idcf2">
                {toCurrency(tuition.inDistrictTuitionAndFeesSecondYear)}
              </td>
              <td className="idcf3">
                {toCurrency(tuition.inDistrictTuitionAndFeesThirdYear)}
              </td>
              <td className="idcf4">
                {toCurrency(tuition.inDistrictTuitionAndFeesFourthYear)}
              </td>
            </tr>
            <tr className="odd">
              <td>{t`In State`}</td>
              <td className="iscf1">
                {toCurrency(tuition.inStateTuitionAndFeesFirstYear)}
              </td>
              <td className="iscf2">
                {toCurrency(tuition.inStateTuitionAndFeesSecondYear)}
              </td>
              <td className="iscf3">
                {toCurrency(tuition.inStateTuitionAndFeesThirdYear)}
              </td>
              <td className="iscf4">
                {toCurrency(tuition.inStateTuitionAndFeesFourthYear)}
              </td>
            </tr>
            <tr className="even">
              <td>{t`Out Of State`}</td>
              <td className="oscf1">
                {toCurrency(tuition.outOfStateTuitionAndFeesFirstYear)}
              </td>
              <td className="oscf2">
                {toCurrency(tuition.outOfStateTuitionAndFeesSecondYear)}
              </td>
              <td className="oscf3">
                {toCurrency(tuition.outOfStateTuitionAndFeesThirdYear)}
              </td>
              <td className="oscf4">
                {toCurrency(tuition.outOfStateTuitionAndFeesFourthYear)}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <table className="tbl costs-table">
          <thead>
            <tr>
              <th>{t`Cost`}</th>
              <th className="ay1">{tuition.firstYear}</th>
              <th className="ay2">{tuition.secondYear}</th>
              <th className="ay3">{tuition.thirdYear}</th>
              <th className="ay4">{tuition.fourthYear}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="even">
              <td>{t`Books`}</td>
              <td className="bookf1">{toCurrency(tuition.booksFirstYear)}</td>
              <td className="bookf2">{toCurrency(tuition.booksSecondYear)}</td>
              <td className="bookf3">{toCurrency(tuition.booksThirdYear)}</td>
              <td className="bookf4">{toCurrency(tuition.booksFourthYear)}</td>
            </tr>
            <tr className="odd">
              <td>{t`Room & Board`}</td>
              <td className="roomf1">{toCurrency(tuition.roomAndBoardFirstYear)}</td>
              <td className="roomf2">{toCurrency(tuition.roomAndBoardSecondYear)}</td>
              <td className="roomf3">{toCurrency(tuition.roomAndBoardThirdYear)}</td>
              <td className="roomf4">{toCurrency(tuition.roomAndBoardFourthYear)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="section tuition-section sections">
      {tuition?.firstYear ? (
        data()
      ) : (
        <p>{t`Tuition figures are not available for this institution`}</p>
      )}
    </div>
  )
}

export { Tuition }
